// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";

import VirtualList from "src/components/VirtualList";
import Accordion from "src/components/Accordion";

type Props = {
  title: number,
  count: number,
  header?: string,
  render: Function,
};

const SegmentedList = ({
  count,
  render,
  title,
  header = i18n.t(k.STATUS),
}: Props) => {
  return (
    <Accordion title={title} count={count} header={header}>
      <VirtualList
        initialAmount={20}
        progressiveAmount={20}
        role="list"
        renderItem={render}
        renderLoader={() => <div />}
        rowCount={count}
      />
    </Accordion>
  );
};

export default SegmentedList;
